/**
 * Divider Block Configuration
 *
 * Registry config for the horizontal rule divider block type.
 */

import { Minus } from "lucide-react";
import { DividerBlock } from "@/canvas/components/blocks/DividerBlock";
import type { BlockConfig } from "../types";

export const dividerBlockConfig: BlockConfig<"divider"> = {
  type: "divider",
  component: DividerBlock,
  icon: Minus,
  iconClassName: "text-stone-400",
  label: "canvas.blockTypes.divider",
  defaultContent: () => ({}),
};
